import { useQuery } from "@tanstack/react-query";
import { getNeighbourhoodSuggestions, NeighbourhoodSuggestionResult } from "../../apis/search";

/**
 * Hook to fetch all neighborhood suggestions
 * Used for the expanded "All Neighborhoods" view
 * @param enabled - Whether to fetch data (only enabled when expanded view is active)
 * @param latitude - Optional user latitude to pass to the API
 * @param longitude - Optional user longitude to pass to the API
 */
export function useAllNeighborhoodSuggestions(
  enabled: boolean = false,
  latitude?: number | null,
  longitude?: number | null,
) {
  return useQuery<NeighbourhoodSuggestionResult, Error>({
    queryKey: ["allNeighbourhoodSuggestions", latitude ?? null, longitude ?? null],
    queryFn: () => getNeighbourhoodSuggestions(undefined, latitude, longitude),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
